import React, {useContext} from "react"
import {CategoryHelper, CategoryHelperContext} from "../../../../services/helpers/category-helper"
import styles from "./category-settings.module.scss"

export const DefaultExcludeCategoryIds = [55, 59, 62, 66]

export interface CategorySettingsProps {
  excludeCategoryIds: number[]
  toggleExcludeCategory: (categoryId: number) => void
}

export const CategorySettings: React.FC<CategorySettingsProps> = ({excludeCategoryIds, toggleExcludeCategory}) => {
  const categoryHelper = useContext<CategoryHelper | null>(CategoryHelperContext)

  if (categoryHelper === null) return <></>
  return <div className={styles.CategorySettings}>
    {categoryHelper.categoryTree.map(topCategory =>
      <div key={topCategory.id}>
        <h5><input type="checkbox" checked={excludeCategoryIds.indexOf(topCategory.id) === -1} onChange={() => toggleExcludeCategory(topCategory.id)}/> {topCategory.name}</h5>
        {topCategory.subCategories.map(subCategory =>
          <div key={subCategory.id}><input type="checkbox" disabled={excludeCategoryIds.indexOf(topCategory.id) !== -1} checked={excludeCategoryIds.indexOf(subCategory.id) === -1} onChange={() => toggleExcludeCategory(subCategory.id)}/> <label>{subCategory.name}</label></div>
        )}
      </div>
    )}
  </div>
}